export default __webpack_public_path__ + "static/assets/717d9a307cb4b9564fe9efd2b4b86cec.gif";